import { animate, state, style, transition, trigger } from '@angular/animations';

export namespace TableExpandableRowAnimation {
  export const AnimationDuration = 225;

  const Timing = `${AnimationDuration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`;
  export const Named = (name: string) => [
    trigger(name, [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate(Timing)),
    ]),
  ];
}
